import script from "./indexList.vue?vue&type=script&setup=true&lang=js"
export * from "./indexList.vue?vue&type=script&setup=true&lang=js"

import "./indexList.vue?vue&type=style&index=0&id=10f4218c&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f4218c"]])

export default __exports__